import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'

function DeleteDialog({ isDialogOpen, setDialogOpen, handleConfirmDelete }) {
  return (
    <Dialog
      open={isDialogOpen}
      onClose={() => setDialogOpen(false)}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle variant='h4' id='alert-dialog-title'>
        Request Delete Account
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={() => setDialogOpen(false)}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (_theme) => _theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <Typography variant='subtitle1' sx={{ marginBottom: '24px' }}>
            This account will be deleted.
            <br /> <br />
            This account will no longer be available after deletion.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='filled'
          onClick={handleConfirmDelete}
          data-cy='proceedDelBtn'
        >
          Proceed to Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeleteDialog.propTypes = {
  isDialogOpen: PropTypes.bool,
  setDialogOpen: PropTypes.func,
  handleConfirmDelete: PropTypes.func
}

export default DeleteDialog
